import { render, staticRenderFns } from "./PlaylistEmbed.vue?vue&type=template&id=d05f70a2"
import script from "./PlaylistEmbed.vue?vue&type=script&lang=ts"
export * from "./PlaylistEmbed.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports